import { useEffect } from "react";

const IOS_URL = "https://apps.apple.com/us/app/criccenter/id6475732232";
const ANDROID_URL = "https://play.google.com/store/apps/details?id=com.hashitlabs.criccenter";

const NotFound = () => {
  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || "";
    const platform = navigator.platform || "";
    const isIOS = /iPad|iPhone|iPod/.test(ua) || (platform === "MacIntel" && navigator.maxTouchPoints > 1);
    const isAndroid = /android/i.test(ua);
    const target = isIOS ? IOS_URL : isAndroid ? ANDROID_URL : null;
    if (!target) return;
    const note = document.getElementById("redirect-note");
    if (note) note.textContent = "Opening the app store…";
    const t = setTimeout(() => {
      window.location.replace(target);
    }, 600);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <style>{`
        .nf-wrap { min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 24px; background: radial-gradient(1200px 600px at 50% -10%, #1b2238 0%, #0b0f1a 60%); color: #f4f6fb; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif; }
        .nf-inner { max-width: 480px; width: 100%; text-align: center; }
        .nf-code { font-size: 14px; letter-spacing: 0.2em; color: #9aa3b2; text-transform: uppercase; }
        .nf-title { font-size: clamp(28px, 6vw, 40px); margin: 8px 0 12px; line-height: 1.15; }
        .nf-text { color: #9aa3b2; font-size: 16px; line-height: 1.5; margin: 0 0 28px; }
        .nf-stores { display: flex; gap: 12px; justify-content: center; flex-wrap: wrap; margin-bottom: 20px; }
        .nf-store { display: inline-flex; align-items: center; gap: 10px; padding: 12px 18px; background: #121828; border: 1px solid #1f2940; border-radius: 12px; color: #f4f6fb; text-decoration: none; font-weight: 600; font-size: 15px; transition: transform 0.15s ease, border-color 0.15s ease; }
        .nf-store:hover { transform: translateY(-1px); border-color: #ff6a00; }
        .nf-store svg { width: 22px; height: 22px; flex-shrink: 0; }
        .nf-store small { display: block; font-weight: 400; font-size: 11px; color: #9aa3b2; letter-spacing: 0.04em; }
        .nf-home { display: inline-block; margin-top: 8px; color: #9aa3b2; font-size: 14px; text-decoration: none; border-bottom: 1px dashed #2a3350; }
        .nf-home:hover { color: #f4f6fb; }
        .nf-redirecting { margin-top: 18px; font-size: 13px; color: #9aa3b2; min-height: 18px; }
      `}</style>
      <main className="nf-wrap">
        <div className="nf-inner">
          <div className="nf-code">Error 404</div>
          <h1 className="nf-title">This page doesn&rsquo;t exist</h1>
          <p className="nf-text">Looking for CricCenter? Grab the app for the full experience, or head back to our homepage.</p>
          <div className="nf-stores">
            <a className="nf-store" href={IOS_URL} rel="noopener">
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M16.365 1.43c0 1.14-.47 2.24-1.23 3.04-.82.86-2.14 1.52-3.23 1.43-.14-1.12.43-2.29 1.19-3.02.85-.83 2.26-1.45 3.27-1.45zM20.5 17.23c-.55 1.26-.82 1.82-1.54 2.94-.99 1.53-2.4 3.44-4.14 3.46-1.54.01-1.94-1.01-4.04-1-2.1.01-2.54 1.02-4.09 1-1.74-.02-3.07-1.74-4.06-3.27C.7 17.09.51 12.15 2.85 9.67c1.12-1.2 2.86-1.95 4.47-1.95 1.66 0 2.7.91 4.07.91 1.33 0 2.14-.91 4.06-.91 1.43 0 2.95.78 4.03 2.13-3.54 1.94-2.96 7-.98 7.38z" />
              </svg>
              <span>
                <small>Download on the</small>
                App Store
              </span>
            </a>
            <a className="nf-store" href={ANDROID_URL} rel="noopener">
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M3.609 1.814L13.792 12 3.61 22.186a1 1 0 0 1-.61-.92V2.734a1 1 0 0 1 .61-.92zM14.9 13.108l2.582 2.582-11.84 6.693 9.258-9.275zM20.16 10.46c.67.372 1.02.98 1.02 1.54 0 .56-.35 1.17-1.02 1.54l-2.19 1.25-2.83-2.79 2.83-2.79 2.19 1.25zM5.643 1.53l11.84 6.693-2.582 2.582L5.643 1.53z" />
              </svg>
              <span>
                <small>Get it on</small>
                Google Play
              </span>
            </a>
          </div>
          <a className="nf-home" href="/">Back to criccenter.com</a>
          <div id="redirect-note" className="nf-redirecting" aria-live="polite"></div>
        </div>
      </main>
    </>
  );
};

export default NotFound;
